import { render, staticRenderFns } from "./SelectableExtractionValue.vue?vue&type=template&id=5efce63a&scoped=true&"
import script from "./SelectableExtractionValue.vue?vue&type=script&lang=js&"
export * from "./SelectableExtractionValue.vue?vue&type=script&lang=js&"
import style0 from "./SelectableExtractionValue.vue?vue&type=style&index=0&id=5efce63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efce63a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VHover,VTextField})
